module.exports = __webpack_public_path__ + "img/forgot-password-dark.f1200f0b.svg";